var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { connect } from 'react-redux';

import Doc from "../Library/components/Doc";

import { RowList } from "./Lists";





class TilesViewerComponent extends React.Component {
  render() {
    return /*#__PURE__*/(
      _jsx(RowList, { zoomLevel: this.props.rowListZoomLevel }, void 0,
      this.props.documents.get('rows').map((doc) => /*#__PURE__*/
      _jsx(Doc, {
        doc: doc,
        storeKey: this.props.storeKey,

        onClick: this.props.clickOnDocument,
        onSnippetClick: this.props.onSnippetClick,
        deleteConnection: this.props.deleteConnection,
        searchParams: this.props.search }, doc === null || doc === void 0 ? void 0 : doc.get('_id')
      )
      )
      ));

  }
}

const mapStateToProps = (state, props) => ({
  documents: state[props.storeKey].documents,
  search: state[props.storeKey].search
});

export const TilesViewer = connect(mapStateToProps)(TilesViewerComponent);